module.exports = __webpack_public_path__ + "static/investorPreferenceHeatmap-9ec1a6c1762df8e21b1139c0bcd506fd.png";